const PropTypes = require('prop-types');
// @vendors
const React = require('react');

class BuySellConditionTypeOption extends React.Component {

    constructor(props) {
        super(props);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }

    buildOption() {
        const {option, className} = this.props;
        const {label} = option;
        const optionClassName = `buysell-condition-type-dropdown__option ${className}`;

        return (
            <div className={optionClassName} onMouseDown={this.handleMouseDown} onMouseMove={this.handleMouseMove}>
                <span className="stocks-contract-dropdown__option--highlighted">{label}</span>
            </div>
        );
    }

    handleMouseDown (event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }

    handleMouseMove (event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    }

    render() {
        let result;

        result = this.buildOption();

        return result;
    }
}

BuySellConditionTypeOption.propTypes = {
    className: PropTypes.string,
    option: PropTypes.object.isRequired,
    isFocused: PropTypes.bool,
    onSelect: PropTypes.func,
    onFocus: PropTypes.func
};

module.exports = BuySellConditionTypeOption;